/** The terms a customer or an invoice can have. A value is days, and empty is no terms (ADR-0039). */
export const PAYMENT_TERMS = [
  { value: "", label: "No payment terms" },
  { value: "0", label: "Due on receipt" },
  { value: "7", label: "Net 7" },
  { value: "15", label: "Net 15" },
  { value: "30", label: "Net 30" },
  { value: "45", label: "Net 45" },
  { value: "60", label: "Net 60" },
];

/** How terms read. A number of days the list doesn't offer reads as Net that number. */
export function termsLabel(days: string): string {
  return PAYMENT_TERMS.find((term) => term.value === days)?.label ?? `Net ${days}`;
}

/** The due date terms give an invoice, or empty with no terms or no date. */
export function dueFrom(invoiceDate: string, days: string): string {
  if (days === "" || invoiceDate === "") return "";
  const at = Date.parse(`${invoiceDate}T00:00:00Z`);
  return Number.isNaN(at)
    ? ""
    : new Date(at + Number(days) * 86_400_000).toISOString().slice(0, 10);
}
